export default __webpack_public_path__ + "static/8-f8eebc604614b200c47087015e682d9e.png";